import { API_URL } from '../../../utils/config';

export const GET_WIFICALL_USER_BY_ID_URL = `${API_URL}/wificall/getsupport`;
export const GET_WIFICALL_USER_SIP_DETAILS_URL = `${API_URL}/wificall/admin/username`;
export const VERIFY_WIFICALL_USER_BY_USER_ID = `wificall/support`;
export const GET_WIFICALL_USERS_URL = `${API_URL}/wificall/users`;
export const WIFICALL_ADMIN_EDIT_USER_URL = `${API_URL}/wificall/user`;
export const ADD_WIFICALL_USER_URL = `${API_URL}/wificall/users1.0`;
export const GET_CUSTOMER_WIFICALL_NUMBER_URL = `${API_URL}/numbers/admin/assign`;
